import Row from "@Containers/components/Row";
import IconSwitch from "@Icons/IconSwitch";
import React from "react";
import {useTranslation} from "@Translation/hooks/useTranslation";
import IconLocationMarker from "@Icons/IconLocationMarker";
import {Colors} from "@Styles/Colors.style";
import IconRating from "@Icons/IconRating";

function ReviewShortContent({review}) {
    const stationKey = review?.lang ? (review.lang == "en" ? "Name" : `Name${review.lang.replace("-", "_").toUpperCase()}`) : "Name"
    const by = useTranslation("c_profile.by")
    const username = review?.real_name ? review.real_name.toUpperCase() : "ANONYMOUS"
    return (
        <div>
                <span className="gb--review-rating-container">
                    <div className="gb--review-rating-value">
                        <IconRating
                            width={14}
                            height={14}
                            fill={Colors.warningColor}
                            stroke={Colors.warningColor}
                        />
                        <span>{review.rating}</span>
                    </div>
                    <span>
                        {by}
                        {' '}
                        {username}
                    </span>
                </span>
            {review?.stationToStationUrl && review?.departureStation && (
                <Row center gap className="gb--review-route">
                    <IconSwitch fill={Colors.primaryColor}/>
                    <a href={review.stationToStationUrl}>
                        {review.departureStation[stationKey]}
                        -
                        {review.destinationStation[stationKey]}
                    </a>
                </Row>
            )}
            {review?.companyUrl && (
                <Row center gap className="gb--review-route">
                    <a href={review.companyUrl}>
                        {review.Name}
                    </a>
                </Row>
            )}
            {review?.stop && (
                <Row center gap className="gb--review-route">
                    <IconLocationMarker fill={Colors.primaryColor}/>
                    {review.stop}
                </Row>
            )}
        </div>
    )
}

export default ReviewShortContent